import { useDispatch } from 'react-redux';

import { useComplianceLevelState, useDeviceState } from '@/hooks/store';
import { setComplianceLevel } from '@/store/complianceLevel/actions';
import { IS_GDPR_LIMITED, IS_LIMITED, REQUIRE_GDPR_MODAL } from '@/store/complianceLevel/types';
import { setUser } from '@/store/user/actions';
import { User } from '@/store/user/types';
import { setAmplitudeUserProperties } from '@/utils/analytics/amplitude';
import { CalmAuthMethods, setUserCookies } from '@/utils/privacyCookies';
import { setNextLocaleCookie } from '@/utils/setNextLocaleCookie';

export default function useSetupSleepUserAfterAuth() {
	const dispatch = useDispatch();
	const complianceLevel = useComplianceLevelState();
	const device = useDeviceState();

	const setupUserAfterAuth = async (user: User, authMethod?: CalmAuthMethods) => {
		setUserCookies(user, authMethod);
		setNextLocaleCookie(device?.language);
		if (user.has_opted_in_limited_data_use) {
			user.compliance_level = complianceLevel === REQUIRE_GDPR_MODAL ? IS_GDPR_LIMITED : IS_LIMITED;
			dispatch(setComplianceLevel(user.compliance_level));
		}
		dispatch(setUser(user));

		const has_opted_in_limited_data_use =
			complianceLevel === IS_GDPR_LIMITED || complianceLevel === IS_LIMITED;

		if (!user.has_opted_in_limited_data_use && has_opted_in_limited_data_use) {
			setAmplitudeUserProperties({
				ldu_opt_in_at: new Date().toISOString(),
			});
		}
	};

	return setupUserAfterAuth;
}
